import { useNavigate } from "react-router-dom";
import { Wordmark } from "./Icon.jsx";

// ─── FOOTER ──────────────────────────────────────────────────────────────────
// Light footer from the redesign: brand, link columns, contact, legal line. Hairlines, no dark band.
const linkBtn = { background: "none", border: "none", padding: 0, cursor: "pointer", textAlign: "left", fontFamily: "inherit", fontSize: 14, color: "var(--text2)", lineHeight: 2 };
const head = { fontSize: 14, fontWeight: 600, color: "var(--ink)", marginBottom: 4 };

export function Footer() {
  const navigate = useNavigate();
  const Col = ({ title, items }) => (
    <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-start" }}>
      <div style={head}>{title}</div>
      {items.map(([label, to]) => <button key={label} onClick={() => navigate(to)} style={linkBtn}
        onMouseOver={e => e.currentTarget.style.color = "var(--ink)"} onMouseOut={e => e.currentTarget.style.color = "var(--text2)"}>{label}</button>)}
    </div>
  );
  return (
    <footer style={{ background: "var(--white)", borderTop: "1px solid var(--border)", color: "var(--text2)", fontFamily: "'Syne', sans-serif" }}>
      <div style={{ maxWidth: 1360, margin: "0 auto", padding: "40px 40px 28px", display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(150px, 1fr))", gap: 28 }}>
        <div style={{ gridColumn: "span 2", minWidth: 220 }}>
          <Wordmark size={30} />
          <p style={{ margin: "12px 0 0", fontSize: 14, color: "var(--ink-soft)", lineHeight: 1.55, maxWidth: 300 }}>A marketplace for independent Instagram sellers and the people who shop them.</p>
        </div>
        <Col title="Shop" items={[["New arrivals", "/"], ["All stores", "/directory"]]} />
        <Col title="Sell" items={[["Open a store", "/signup"], ["Business login", "/login"], ["Customer login", "/customer/login"]]} />
        <Col title="Company" items={[["About", "/about"], ["Privacy policy", "/privacy"], ["Terms", "/terms"], ["Refund policy", "/refund"]]} />
        <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-start" }}>
          <div style={head}>Contact</div>
          <a href="mailto:ordersbloomhq@gmail.com" style={{ ...linkBtn, textDecoration: "none", overflowWrap: "anywhere" }}>ordersbloomhq@gmail.com</a>
        </div>
      </div>
      <div style={{ borderTop: "1px solid var(--border)" }}>
        <div style={{ maxWidth: 1360, margin: "0 auto", padding: "16px 40px", display: "flex", flexWrap: "wrap", gap: 12, justifyContent: "space-between", fontSize: 13, color: "var(--ink-soft)" }}>
          <span>© {new Date().getFullYear()} BLOOMHQ PRIVATE LIMITED. All rights reserved.</span>
          <span>Payments processed by Razorpay</span>
        </div>
      </div>
    </footer>
  );
}
